import axios from "axios";
import store, { persistor } from "../store";

export const API_URL = process.env.REACT_APP_API_URL ||
    ((process.env.NODE_ENV === "production") ? "https://api.socialcompliance.in/api/v1" : 'http://localhost:3002/api/v1');


export const fileUrl = (id: string) => {
    const raw = localStorage.getItem("token")
    // Only append auth when we actually have a token, otherwise the URL carries
    // the literal string "Bearer null" and guarantees a confusing 401.
    const auth = raw ? '?authorization=Bearer ' + raw : ''
    return API_URL + '/file/' + id + auth;
}

// Clears the session (token + all persisted redux state) and returns to login.
// Used by the Logout page and by the 401 interceptor when a token expires.
// The hard reload guarantees no in-memory state survives onto a shared machine.
export const forceLogout = () => {
    try { localStorage.removeItem("token") } catch (e) { /* ignore */ }
    const done = () => {
        if (!window.location.hash.includes("/login")) {
            window.location.replace(window.location.origin + "/#/login")
        }
        window.location.reload()
    }
    persistor.purge().then(done).catch(done)
}

const instance = axios.create({
    baseURL: API_URL
    // timeout: 1000,
    // headers: { 'X-Custom-Header': 'foobar' }
}); 

// Add a request interceptor
instance.interceptors.request.use(async function (config) {
    // Do something before request is sent
    let token = localStorage.getItem("token")

    if (token) {
        const headers = (config.headers) ? config.headers : {};
        config.headers = { 'Authorization': 'Bearer ' + token, ...headers, };
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    // A 401 means the token is missing/expired/invalid. If we were holding a
    // token, it has gone stale — clear the session and send the user to login.
    // (403 = authenticated but forbidden; we deliberately do NOT log out on it.)
    if (error && error.response && error.response.status === 401 && localStorage.getItem("token")) {
        forceLogout();
    }
    return Promise.reject(error);
});

export default instance;